import { baseApiV2 } from '@verantos-dev/app-state-base';
import { getProjectsBasePath } from '@verantos-dev/core-constants';
import { type CohortSubjectDetail } from '@verantos-dev/types-cohorts';
import { QueryUtil, type ListResponse } from '@verantos-dev/types-common';

import { transformCohortSummaryDetailForDisplay } from './helpers';

export const subjectApiSlice = baseApiV2
  .enhanceEndpoints({
    addTagTypes: ['subjects'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getSubjectsByProfileId: builder.query<
        ListResponse<CohortSubjectDetail>,
        { projectId: string; cohortProfileId: string; urlParams?: string }
      >({
        query: ({ projectId, cohortProfileId, urlParams }) => {
          const searchStr = new URLSearchParams(urlParams).toString();
          return `${getProjectsBasePath()}/${projectId}/cohort-profile/${cohortProfileId}/subjects${
            searchStr ? `?${searchStr}` : ''
          }`;
        },
        transformResponse: (response: ListResponse<CohortSubjectDetail>) => {
          return {
            ...response,
            data: transformCohortSummaryDetailForDisplay(response.data),
          };
        },
        providesTags: (result, error, { cohortProfileId }) => [
          { type: 'subjects', id: cohortProfileId },
        ],
      }),
    }),
  });

export const { useGetSubjectsByProfileIdQuery, useLazyGetSubjectsByProfileIdQuery } =
  subjectApiSlice;
